
import { Base } from '../base-component';
import './supporting-detail-card.component.scss';

export class SupportingDetailCard extends Base {

	constructor(element: Element){
		super(element);
	}

	init() {}

	bindEvents() {}

}



// WEBPACK FOOTER //
// ./components/supporting-detail-card/supporting-detail-card.component.ts